var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDailyRuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5297_2555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.204 2.16196C21.063 1.20996 19.57 0.818964 18.106 1.08096L14.284 1.77596C13.371 1.94296 12.578 2.40996 12 3.06496C11.422 2.40996 10.629 1.94196 9.715 1.77596L5.894 1.08096C4.433 0.817964 2.938 1.20996 1.796 2.16196C0.654 3.11496 0 4.51396 0 6.00096V16.793C0 19.21 1.727 21.279 4.106 21.712L10.39 22.855C10.924 22.952 11.462 23.001 12 23.001C12.538 23.001 13.076 22.953 13.61 22.855L19.895 21.712C22.274 21.279 24 19.21 24 16.793V6.00096C24 4.51396 23.345 3.11496 22.204 2.16196ZM11 20.928C10.916 20.916 10.832 20.902 10.748 20.887L4.464 19.744C3.036 19.484 2 18.243 2 16.792V6.00096C2 5.10896 2.393 4.26996 3.078 3.69796C3.623 3.24296 4.301 3.00096 4.997 3.00096C5.176 3.00096 5.357 3.01696 5.537 3.04996L9.358 3.74496C10.31 3.91796 11.001 4.74596 11.001 5.71296V20.929L11 20.928ZM22 16.793C22 18.244 20.964 19.485 19.537 19.745L13.253 20.888C13.169 20.903 13.085 20.917 13.001 20.929V5.71196C13.001 4.74496 13.692 3.91796 14.643 3.74396L18.464 3.04896C19.342 2.88696 20.237 3.12596 20.923 3.69696C21.608 4.26896 22.001 5.10796 22.001 5.99996V16.792L22 16.793ZM5.5 13V6.99996C5.5 6.44796 5.948 5.99996 6.5 5.99996C7.052 5.99996 7.5 6.44796 7.5 6.99996V13C7.5 13.552 7.052 14 6.5 14C5.948 14 5.5 13.552 5.5 13ZM8 16.5C8 17.328 7.328 18 6.5 18C5.672 18 5 17.328 5 16.5C5 15.672 5.672 15 6.5 15C7.328 15 8 15.672 8 16.5Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5297_2555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyRuleIcon);
export default __webpack_public_path__ + "static/media/daily-rule-icon.cc43e980f351539e5e36f06de0c30776.svg";
export { ForwardRef as ReactComponent };